import { render } from "./PreviousLectureTeacher.vue?vue&type=template&id=bbb3106c&scoped=true"
import script from "./PreviousLectureTeacher.vue?vue&type=script&lang=js"
export * from "./PreviousLectureTeacher.vue?vue&type=script&lang=js"

import "./PreviousLectureTeacher.vue?vue&type=style&index=0&id=bbb3106c&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbb3106c"]])

export default __exports__